import { render, staticRenderFns } from "./matches-subpage.vue?vue&type=template&id=3303ff11&lang=pug&"
import script from "./matches-subpage.vue?vue&type=script&lang=js&"
export * from "./matches-subpage.vue?vue&type=script&lang=js&"
import style0 from "./matches-subpage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports